"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStartDate = createStartDate;
exports.createEndDate = createEndDate;
exports.formatDate = formatDate;
exports.dateToFilterDateRange = dateToFilterDateRange;
const dayjs_1 = require("../../utils/dayjs");
const constants_1 = require("../../domain/results/constants");
function createStartDate(date) {
    return date ? (0, dayjs_1.dayjsCore)(date).startOf('day').toDate() : undefined;
}
function createEndDate(date) {
    return date ? (0, dayjs_1.dayjsCore)(date).endOf('day').toDate() : undefined;
}
function formatDate({ date, format, }) {
    return date && (0, dayjs_1.dayjsCore)(date).format(format);
}
function dateToFilterDateRange(date) {
    return {
        scheduledFrom: formatDate({
            date: createStartDate(date),
            format: constants_1.DATE_FORMAT,
        }),
        scheduledTo: formatDate({
            date: createEndDate(date),
            format: constants_1.DATE_FORMAT,
        }),
    };
}
//# sourceMappingURL=utils.js.map